/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { GET_QR_CODES_SUCCESS } from '../constants/actions';

export const passesInitialState = {
    qrCode: '',
};

export const passesReducers = (state = passesInitialState, action) => {
    switch (action.type) {
        case GET_QR_CODES_SUCCESS:
            return {
                ...state,
                qrCode: action.payload.qr_code,
            };
        default:
            return state;
    }
};
